module.exports = __webpack_public_path__ + "static/media/17_5.66f93437.jpg";